/* eslint-disable no-undef */
/**
 * site-scripts.js
 *
 * All general site scripts
 */

import Swiper from 'swiper/bundle';
import { groupEventListener } from './utils';





(function ($) {
	// Header Events

	const body = document.body;
	$(document).on('ready', function () {
		// Replace any href="#" links with href="javascript:void(0)"
		if (document.body.contains(document.querySelector('[href="#"]'))) {
			const emptyHrefs = Array.prototype.slice.call(
				document.querySelectorAll('[href="#"]')
			);
			emptyHrefs.forEach((link) => {
				link.href = 'javascript:void(0)';
			});
		}

		// Add .js-subnav-toggle class to any mobile nav items with children
		if (
			document.body.contains(
				document.querySelector('.menu-item-has-children')
			)
		) {
			const topLevelItems = Array.prototype.slice.call(
				document.querySelectorAll('.menu-item-has-children')
			);
			topLevelItems.forEach((item) => {
				item.classList.add('js-subnav-toggle');
			});
		}

		if (
			document.body.contains(document.querySelector('.js-modal')) ||
			document.body.classList.contains('search')
		) {
		}
	});

	// accordion new

	var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0 ; i < acc.length ; i++){
      acc[i].addEventListener("click" , function(){
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if(panel.style.maxHeight){
          panel.style.maxHeight = null;
        }
        else{
          panel.style.maxHeight = panel.scrollHeight + "px"
        }
      });

      
    }


	// Swiper JS Homepage
	var sliderSelector = '.swiper-container',
    options = {
      init: false,
    autoplay: {delay: 7000,},
      loop: true,
      speed: 400,
      slidesPerView: 1, // or 'auto'
      centeredSlides : true,
      effect: 'coverflow', // 'cube', 'fade', 'coverflow',
      coverflowEffect: {
        rotate: 0, // Slide rotate in degrees
        stretch: 0, // Stretch space between slides (in px)
        depth: 0, // Depth offset in px (slides translate in Z axis)
        modifier: 1, // Effect multipler
        slideShadows : true, // Enables slides shadows
      },
      grabCursor: true,
      parallax: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1023: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      },
    };
	var mySwiper = new Swiper(sliderSelector, options);

	// Initialize slider
	mySwiper.init();




	// Expandable Modules:
	// 1. Features Module

	function expandModule() {
		const openToggle = document.querySelector('.-is-expanded');
		if (openToggle && openToggle !== this) {
			openToggle.classList.remove('-is-expanded');
		}
		this.classList.toggle('-is-expanded');
	}

	if (document.body.classList.contains('page-template-page-membership')) {
		document.addEventListener(
			'click',
			function (event) {
				if (event.target.closest('.js-expand')) return;
				document
					.querySelector('.-is-expanded')
					.classList.remove('-is-expanded');
			},
			false
		);
	}



	// Mailchimp Newsletter Form
	$('#mc_mv_EMAIL').attr('placeholder', $('label.mc_header_email').html());
	$('label.mc_header_email').hide();
	$('.mc_email_format').parent().hide();

	// Contact Form 7

	$('.wpcf7-select#how-heard option[value=""]').attr('disabled', 'disabled');

	$('.wpcf7-form').removeAttr('novalidate');
	$('.wpcf7-validates-as-required').prop('required', true); // Adjust Contact Form 7 Default Behavior

	$('.wpcf7-form').on('submit', function (event) {
		const $successElement = $('.wpcf7-response-output');
		$successElement.text('Thank you for your submission');
		$successElement.show();
	});
	$(document).on('click', '.opt-in__close', closeCookieBanner);

	function closeCookieBanner() {
		$('#pi_tracking_opt_in_div').addClass('hide');
		setTimeout(function () {
			$('#pi_tracking_opt_in_no').click();
		}, 500);
	}


})(jQuery);
